export class LabIdManager {
  public static labId: string;

  constructor() {}
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/labIdManager.ts